import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { ICellRendererParams } from 'ag-grid-community';
import { Button, InputGroup } from '@blueprintjs/core';
import { TranslatedMessage } from '../common/translation';
import { SecretariatStore } from '../../store/SecretariatStore';
import { Link } from 'react-router-dom';
import { Page, TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import { ApplicationStore } from '../../store';
import styled from '@emotion/styled';
import BaseGrid from '../common/grid/BaseGrid';
import MainSectionLayout from '../layout/MainSectionLayout';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import EditCell from '../common/grid/EditCell';

const ContainerCol = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const DivLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-right: 5%;
  padding-bottom: 5px;
`;
const DivRight = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
  .bp3-icon {
    margin-right: 3px;
  }
`;

interface SecretariatListPageProps {
  SecretariatStore?: Instance<typeof SecretariatStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
}

interface SecretariatListPageState {
  isLoading: boolean;
  filter: string;
  columnDefs: any;
  api?: any;
  columnApi?: any;
}

@inject('SecretariatStore', 'ApplicationStore')
@observer
class SecretariatListPage extends React.Component<
  SecretariatListPageProps & WithTranslateProps,
  SecretariatListPageState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: false,
      filter: '',
      columnDefs: [
        {
          headerName: this.props.translate(TLCode.SECRETARIAT_Code),
          width: 200,
          filter: false,
          field: 'code',
          sortingOrder: ['asc', 'desc'],
        },
        {
          headerName: this.props.translate(TLCode.SECRETARIAT_Name),
          width: 200,
          filter: false,
          sort: 'asc',
          field: 'name',
        },
        {
          headerName: this.props.translate(TLCode.SECRETARIAT_Address),
          width: 200,
          filter: false,
          sort: 'asc',
          field: 'address',
        },
        {
          headerName: this.props.translate(TLCode.SECRETARIAT_Language),
          width: 200,
          filter: false,
          field: 'language',
        },
        {
          headerName: '',
          width: 100,
          suppressSorting: true,
          filter: false,
          cellRendererFramework: EditCell,
          cellRendererParams: (params: ICellRendererParams) => {
            return {
              onEditButtonClick: () => {
                this.props.ApplicationStore!.navigate(`${Page.SecretariatPage}/${params.data.id}`);
              },
            };
          },
        },
      ],
    };
  }

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    const { SecretariatStore } = this.props;
    this._isMounted && this.setState({ isLoading: true });
    await SecretariatStore!.checkListLoaded(); // loadList();
    this._isMounted && this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  buildGridData = () => {
    return this.props.SecretariatStore!.dataList.map((secretariat) => {
      return {
        id: secretariat.secretariatId,
        name: secretariat.name,
        code: secretariat.code,
        address: secretariat.address,
      };
    });
  };

  setFilterText(filter) {
    this.setState({
      filter,
    });
  }

  private onRowDoubleClicked = (ev) => {
    this.props.ApplicationStore!.navigate(`${Page.SecretariatPage}/${ev.data.id}`);
  };

  public render() {
    return (
      <MainSectionLayout isLoading={this.state.isLoading} title={TLCode.SECRETARIATS_Title}>
        <ContainerCol>
          <DivLine>
            <DivLeft>
              <InputGroup
                placeholder="Filter"
                leftIcon="search"
                value={this.state.filter}
                onChange={(e) => this.setFilterText(e.target.value)}
              />
            </DivLeft>
            <DivRight>
              <Link to={Page.SecretariatPage}>
                <Button intent="primary">
                  <TranslatedMessage id={TLCode.Add} />
                </Button>
              </Link>
            </DivRight>
          </DivLine>
          <BaseGrid
            keyName="id"
            columnDefs={this.state.columnDefs}
            rowData={this.buildGridData()}
            loading={this.state.isLoading}
            quickFilterText={this.state.filter}
            onRowDoubleClicked={this.onRowDoubleClicked}
          />
        </ContainerCol>
      </MainSectionLayout>
    );
  }
}

export default withTranslate(SecretariatListPage);
